module.exports = __webpack_public_path__ + "static/img/bank_0237.c055c82.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bank_0237.jpg
// module id = d2ce
// module chunks = 3